import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { TransferCarrierList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useTransferCarriers() {
	/** Query */
	const query = useQuery({
		queryKey: ["transfer-carriers"],
		queryFn: async () => {
			const response = await client.stock["transfer-carriers"].$get();
			const data = await responseHandler(response);
			return data.transferCarriers as TransferCarrierList;
		},
	});

	/** Return */
	return { ...query, transferCarriers: (query.data || []) as TransferCarrierList };
}
